import Rails from "@rails/ujs";
window.Rails = Rails;
if(Rails.fire(document, "rails:attachBindings")) { Rails.start(); }

// React components — явная регистрация вместо require.context
import ReactRailsUJS from "react_ujs";
import Cart from "../javascripts/components/Cart/Cart";
import ProductDetailedMenu from "../javascripts/components/ProductDetailedMenu";
import ProductDocuments from "../javascripts/components/ProductDocuments";
import PropertyTooltip from "../javascripts/components/PropertyTooltip";
import ProductDocumentModal from "../javascripts/components/ProductDocumentModal";

const components = {
  'Cart/Cart': Cart,
  'ProductDetailedMenu': ProductDetailedMenu,
  'ProductDocuments': ProductDocuments,
  'PropertyTooltip': PropertyTooltip,
  'ProductDocumentModal': ProductDocumentModal,
};
ReactRailsUJS.getConstructor = (name) => components[name];

import '../css/rslider.css';
import '../css/application.sass';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import '../javascripts/helpers/ResizeSensor'
import "../javascripts/globalEventListener"
import "../javascripts/overlay"
import "../javascripts/category-menu"
import "../javascripts/sticky-header"
import "../javascripts/slider-init"
import "../javascripts/number-property-slider"
import "../javascripts/product-variant-switcher"
import "../javascripts/product-quantity-change"
import "../javascripts/categories-filter"
import "../javascripts/swiper-init"
import "../javascripts/company-map"
import "../javascripts/cart"
import "../javascripts/catalog"
import "../javascripts/search"
import "../javascripts/yandex-mertika"
// import '../javascripts/sticky-sidebar'
import '../javascripts/show-more'
import '../javascripts/show-more-similar'
import '../javascripts/scroll-top'
import '../javascripts/rslider'
import '../javascripts/cookie-consent'
import '../javascripts/bootstrap.min'
import ahoy from 'ahoy.js';

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.phone-link').forEach(function(link) {
    link.addEventListener('copy', function() {
      ahoy.track('Phone copied', {
        phone_number: this.textContent,
        page: window.location.pathname
      });
    });

    link.addEventListener('click', function() {
      ahoy.track('Phone clicked', {
        phone_number: this.textContent,
        page: window.location.pathname
      });
    });
  });

  document.querySelectorAll('form').forEach(function(form) {
    form.addEventListener('submit', function(e) {
      console.log(this)
      ahoy.track('Form Submitted', {
        form_action: this.action,
        form_method: this.method,
      });
    });
  });

  document.querySelectorAll('.email-link').forEach(function(link) {
    link.addEventListener('copy', function() {
      ahoy.track('Email copied', {
        email: this.textContent,
        page: window.location.pathname
      });
    });

    link.addEventListener('click', function() {
      ahoy.track('Email clicked', {
        email: this.textContent,
        page: window.location.pathname
      });
    });
  });
})